module.exports = __webpack_public_path__ + "img/icon-guide-fb23c732.svg";